import { Card, Descriptions } from 'antd'
import { useTranslation } from 'react-i18next'

import type { ReturnRoot } from '@repo/sdk'

import { StatusBadge } from '../../components/StatusBadge'
import { useReturnStatusConfig } from './returnStatusConfig'
import { useReturnReasonLabels, type ReturnReason } from './returnReasonConfig'
import { formatKstDateTime } from '../../utils/formatKstDateTime'

interface ReturnInfoCardProps {
  returnData: ReturnRoot
}

export function ReturnInfoCard({ returnData }: ReturnInfoCardProps) {
  const { t } = useTranslation()
  const statusConfig = useReturnStatusConfig()
  const reasonLabels = useReturnReasonLabels()

  return (
    <Card title={t('pages.returns.sections.returnInfo')} bordered>
      <Descriptions column={1} size="small">
        <Descriptions.Item label={t('pages.returns.fields.returnId')}>
          {returnData.returnId}
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.returns.fields.status')}>
          <StatusBadge status={returnData.status} configMap={statusConfig} />
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.returns.fields.reasonType')}>
          {reasonLabels[returnData.returnReason as ReturnReason] ?? returnData.returnReason}
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.returns.fields.description')}>
          {returnData.returnDescription ?? '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.returns.fields.requestDateTime')}>
          {formatKstDateTime(returnData.requestedAt, 'YYYY-MM-DD HH:mm:ss')}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  )
}
